<template>
    <div class="msg-subscr-msanage">
        <div class="hint block mb10">
            <div class="title">温馨提示</div>
            <p>逐条检查：一条一条的检查，因数据较多花费时间较长</p>
        </div>
        <div class="hint block mb10">
            <p>逐条检查导入：一条一条的检查并导入，因数据较多花费时间较长</p>
        </div>
        <div class="hint block">
            <p>导入excel文件的单元格格式推荐使用常规或文本</p>
        </div>
        <div class="message-body mt10">
            <ul class="native-table">
                <li class="table-tr">
                    <div class="table-th" style="text-align: left">列名</div>
                    <div class="table-th" style="width: 120px">是否必填</div>
                    <div class="table-th" style="text-align: left">其他要求</div>
                    <!--<div class="table-th" style="text-align: left">正确示例</div>-->
                    <div class="table-th">不符合要求的结果</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">供应商名称</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中手动修改，导入列中不可重复且不可与系统同供应商名称重复</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">统一社会信用代码</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中手动修改，导入列中不可重复</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">省</div>
                    <div class="table-td">否</div>
                    <div class="table-td" style="text-align: left">可在系统中手动输入</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td"> - </div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">市</div>
                    <div class="table-td">否</div>
                    <div class="table-td" style="text-align: left">可在系统中手动输入</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td"> - </div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">县/区</div>
                    <div class="table-td">否</div>
                    <div class="table-td" style="text-align: left">可在系统中手动输入</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td"> - </div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">详细地址</div>
                    <div class="table-td">否</div>
                    <div class="table-td" style="text-align: left">可在系统中手动输入</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td"> - </div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">联系人</div>
                    <div class="table-td">否</div>
                    <div class="table-td" style="text-align: left">可在系统中手动输入</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td"> - </div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">联系手机号</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中手动修改，导入列中不可重复且不可与其他商户管理员账号相同</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">联系邮箱</div>
                    <div class="table-td">否</div>
                    <div class="table-td" style="text-align: left">可在系统中手动输入</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td"> - </div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">关系开始日期</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">格式 yyyy-MM-dd，可在系统中手动设置</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td"> - </div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">关系截止日期</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">格式 yyyy-MM-dd，可在系统中手动设置</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td"> - </div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">评级</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">数字1~5,可在系统中手动设置</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td"> - </div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">业务描述</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">最多60个字符，可在系统中手动填写</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td"> - </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    export default {
        name: 'swb-vendor-format-expl',
        desc: '资产定义导入文件格式说明',
        props: {},
        data: function () {
            return {}
        },
    }
</script>



// WEBPACK FOOTER //
// src/compo/merchant/VendorFormatExpl.vue